import api from '@/api';

import { PageResult } from '@/core/request/PageResult';
import { getUserFromLocalStorage } from '@/utils/user';

import { API_BASE_URL } from '..';
import {
  CostCenter,
  CostCenterRequest,
  ListCostCentersQuery,
} from './CostCenter.types';

const CONTROLLER_URL = `${API_BASE_URL}/costCenters`;

export async function listCostCenters(params: ListCostCentersQuery) {
  const result = (await api.get(`${CONTROLLER_URL}/matrix`, params)) as unknown;

  return result as PageResult<CostCenter>;
}

export async function getCostCenter(id: number) {
  const result = (await api.get(`${CONTROLLER_URL}/${id}`, {})) as unknown;

  return result as CostCenter;
}

export async function createCostCenter(data: CostCenterRequest) {
  const { matrixId } = getUserFromLocalStorage();
  const result = (await api.post(
    `${CONTROLLER_URL}`,
    { ...data, matrixId },
    null,
  )) as unknown;

  return result as void;
}

export async function editCostCenter(data: CostCenterRequest) {
  const { matrixId } = getUserFromLocalStorage();
  const result = (await api.put(
    CONTROLLER_URL,
    { ...data, matrixId },
    null,
  )) as unknown;

  return result as void;
}

export async function removeCostCenter(id: number) {
  const result = (await api.remove(
    `${CONTROLLER_URL}/${id}`,
    {},
    null,
  )) as unknown;

  return result as void;
}

export async function activeOrInactiveCostCenter(id: number) {
  const result = (await api.put(
    `${CONTROLLER_URL}/${id}/active`,
    {},
    null,
  )) as unknown;

  return result;
}
